import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import NotificationItem from './notificationItem';
import FailedTaskItem from './failedTaskItem';

class HeaderNotificationPanel extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.task.fetchTotalFailedTasksCount());

    if (this.props.tab === 'notifications') {
      this.props.dispatch(ReduxActions.notification.fetchPanelList());
    } else {
      this.props.dispatch(ReduxActions.task.fetchFailedTasks());
    }
  }

  _onChangeTab(tab) {
    if (tab === 'notifications') {
      this.props.dispatch(ReduxActions.notification.fetchPanelList());
    } else {
      this.props.dispatch(ReduxActions.task.fetchFailedTasks());
    }
    this.props.onChangeTab(tab);
  }

  _renderSeeAllButton() {
    return (
      <div
        className="vf-header-notification__panel__all"
        onClick={this.props.onClickAll}
      >
        {this.props.strings.buttons.seeAll}
      </div>
    );
  }

  _renderTabBar() {
    const TABS = [{
      value: 'notifications',
      text: this.props.strings.Tab.notifications,
    }, {
      value: 'failedTasks',
      text: (
        <div>
          {this.props.strings.Tab.failureAlerts}
          <span className="vf-header-notification__panel__tab__item__count">
            {this.props.count}
          </span>
        </div>
      ),
    }];

    return (
      <Components.TabBar
        onChange={value => this._onChangeTab(value)}
        options={TABS}
        tabClassName="vf-header-notification__panel__tab__item"
        value={this.props.tab}
      />
    );
  }

  _renderItems(tab) {
    if (tab === 'notifications') {
      return this.props.notifications.map(notification => (
        <NotificationItem
          data={notification}
          key={notification.id}
          onClick={this.props.onClickNotificationItem}
        />
      ));
    }

    return this.props.failedTasks.map(failedTask => (
      <FailedTaskItem
        data={failedTask}
        key={failedTask.date}
        onClick={this.props.onClickFailedTaskItem}
      />
    ));
  }

  _renderLoading(tab) {
    const replaceMap = {
      modelName: tab === 'notifications'
        ? Utils.Formatter.capitalizeEachWord(this.props.strings.modelNamePlural)
        : Utils.Formatter.capitalizeEachWord(this.props.strings.FailedTask.modelNamePlural),
    };

    return (
      <div className="vf-header-notification__panel__loading">
        <Components.EllipsisLoading />
        <div className="vf-header-notification__panel__loading__text">
          {Utils.TranslationHelper.replaceTag(this.props.strings.loading, replaceMap)}
        </div>
      </div>
    );
  }

  render() {
    const { tab } = this.props;

    return (
      <div className="vf-header-notification__panel">
        {this._renderTabBar()}
        <div className="vf-header-notification__panel__list">
          {Utils.Helper.isNullOrUndefined(this.props[tab])
            ? this._renderLoading(tab) : this._renderItems(tab)}
        </div>
        {tab === 'notifications' ? this._renderSeeAllButton() : false}
      </div>
    );
  }
}

HeaderNotificationPanel.displayName = 'Header Notification Panel';

HeaderNotificationPanel.propTypes = {
  count: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  failedTasks: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  notifications: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onChangeTab: PropTypes.func.isRequired,
  onClickAll: PropTypes.func.isRequired,
  onClickFailedTaskItem: PropTypes.func.isRequired,
  onClickNotificationItem: PropTypes.func.isRequired,
  strings: PropTypes.shape().isRequired,
  tab: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const { task, notification } = state;
  return {
    notifications: notification.panelNotifications,
    count: task.totalFailedTasksCount,
    failedTasks: task.failedTasks,
  };
}

export default connect(mapStateToProps)(translate('Notification')(HeaderNotificationPanel));
